////////
// SideMenu Link
////////
var SideMenuLink = function(element) {

	this.selectors = {
		link: ".side-menu-link"
	};

	this.flags = {
		CONTRAST_DARK: "dark",
		CONTRAST_LIGHT: "light",
		ACTIVE: "active"
	}

	this.element = $(element);
  this.element.on("click", this, this.goToAnchorPoint);
	// Get default page colour
	this.pageClass = $("body").attr("class");
}

SideMenuLink.prototype.startMonitor = function() {
  var lastScrollPos = 0;
  var ticking = false;
  var obj = this;

  window.addEventListener('scroll', function(e) {
    lastScrollPos = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function() {
        obj.checkBackgroundContrast();
        ticking = false;
      });
      ticking = true;
    }
  });
}

SideMenuLink.prototype.goToAnchorPoint = function(e) {
  var el = $(e.target);
	var obj = e.data;
  if(el) {
    var targ = document.getElementById(el.attr("href").split("#")[1]);
    if(targ) {
      gsap.to(window, { duration: 2, scrollTo: el.attr("href") });
			el.siblings().removeClass(obj.flags.ACTIVE);
      el.addClass(obj.flags.ACTIVE);
    }
  }
  return(false);
}


SideMenuLink.prototype.setContrast = function(state) {
  if(state == this.flags.CONTRAST_DARK) {
    this.element.addClass("o-style-blue");
    this.element.removeClass("o-style-white");
  } else {
    this.element.addClass("o-style-white");
    this.element.removeClass("o-style-blue");
  }
}


SideMenuLink.prototype.checkBackgroundContrast = function() {

  // Get location
  var position = this.element.offset();
	var y = position.top - window.scrollY + 6;
	var layers = document.elementsFromPoint(50, y);

  // Loop through objects at that location
  for (var i = 0; i < layers.length; i++) {

		// Get layer
		var layer = $(layers[i]);
		var classes = layer.attr("class");

    // Check if it's a block
    if(classes !== undefined && classes.search(/page-style-|block-/) > -1) {

			// Look at block styling
			if(classes.search(/o-style-blue|o-style-green|page-style-green|page-style-blue/) > -1) {

				this.setContrast(this.flags.CONTRAST_LIGHT);
			} else if(classes.indexOf("o-style-none") > -1) {
				// Look at page styling for transparent modules
				if(String(this.pageClass).match(/page-style-green|page-style-blue/)) {
					this.setContrast(this.flags.CONTRAST_LIGHT);
				} else {
					this.setContrast(this.flags.CONTRAST_DARK);
				}
			} else {

				this.setContrast(this.flags.CONTRAST_DARK);
			}

		}
  }
}
